<template>
  <div id="app">
    <!-- <div class="contentar">
      
    </div> -->
    <router-view/>
  </div>
</template>

<script>
import {checkEquipmentFn} from '@/common/common.js'

export default {
  name: 'App',
  created(){
    // this.checkEquipment()
    console.log('这里是app')
    var b = (JSON.stringify(this.$store.state.configInfo) == "{}");
    if(b){
      console.log('数据为空的时候')
      let language = localStorage.getItem('language')
      if(!language){
        language = 'zh'
      }
      // this.$store.dispatch('addSum',{_this: this,language:20 });
      this.$store.commit('setResturantName', {
            _this: this,language:language=='zh'?10:20
        });
    } 
    checkEquipmentFn()
  },
  methods:{
    checkEquipment(){
      const {userAgent} = navigator
      if(userAgent.match(/(Win32 | Win16 | Win64| WinCE | MacIntel|Mac68K | MacPPC | Linux mips64)/i)){
        console.log('电脑')
        if(document.domain=='m.ellassay.com'){
          if(window.location.pathname=='/groupIntroduce'){
            console.log('进来了')
          }else{
            window.location.href=`https://www.ellassay.com${this.$route.path}`
          }
           
        }
        
      }
      if(userAgent.match(/(iPhone | Android | SymbianOS| Windows Phone  | iPod|iPad | Linux armv8l | Linux)/i)){
        console.log('手机') 
        if(document.domain=='www.ellassay.com'){
           window.location.href=`https://m.ellassay.com${this.$route.path}`
        }
      }
    }
  }
}
</script>

<style>
@import '/assets/css/reset.css';
@import '/assets/css/style.css';
.contentar,.videopositionSty{
    min-width: 1200px;
}
.contentar{
  /* padding-bottom: 50px; */
}
/* @media screen and (min-width: 1800px) and (max-width:2000px){
  .contentar{
      min-width: 1600px;
  }
}
@media screen and (min-width: 1500px) and (max-width:1799px){
  .contentar{
      min-width: 1400px;
  }
}
@media screen and (min-width: 1200px) and (max-width:1499px){
  .contentar{
      min-width: 1400px;
  }
} */
video::-webkit-media-controls-fullscreen-button {
    display: none;
}
video::-webkit-media-controls-timeline {
    display: none;
}
video::-webkit-media-controls-current-time-display{
    display: none;            
}
video::-webkit-media-controls-time-remaining-display {
    display: none;            
}
video::-webkit-media-controls-toggle-closed-captions-button {
    display: none;            
}
video::-webkit-media-controls-time-remaining-display {
    display: none;            
}

</style>



// WEBPACK FOOTER //
// src/App.vue